"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ShortcutItem_1 = __importDefault(require("./ShortcutItem"));
exports.default = ShortcutItem_1.default;
